document.addEventListener('DOMContentLoaded',()=>{const btn=document.querySelector('[data-mobile-toggle]');const header=document.querySelector('.gp-header');if(btn&&header){btn.addEventListener('click',()=>{header.classList.toggle('is-open');btn.setAttribute('aria-expanded',header.classList.contains('is-open')?'true':'false')})}});

/* Gallery Privé preview link helper
   Keeps Shopify theme preview parameters when clicking internal links. */
document.addEventListener('DOMContentLoaded', function () {
  var current = new URL(window.location.href);
  var previewThemeId = current.searchParams.get('preview_theme_id');
  var viewParam = current.searchParams.get('view');

  document.querySelectorAll('a[href]').forEach(function (link) {
    var href = link.getAttribute('href');
    if (!href || href.indexOf('#') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;

    try {
      var target = new URL(href, window.location.origin);
      if (target.origin !== window.location.origin) return;

      if (previewThemeId && !target.searchParams.get('preview_theme_id')) {
        target.searchParams.set('preview_theme_id', previewThemeId);
      }

      var cleanPath = target.pathname.replace(/\/$/, '');
      var previewViews = {
        '/pages/art-advisory': 'art-advisory',
        '/pages/journal': 'journal',
        '/pages/about-us': 'about-us',
        '/pages/about': 'about-us'
      };
      if (previewViews[cleanPath] && !target.searchParams.get('view')) {
        target.searchParams.set('view', previewViews[cleanPath]);
      }

      link.setAttribute('href', target.pathname + target.search + target.hash);
    } catch (e) {}
  });
});

/* Version Test — AJAX collector cart drawer */
document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.querySelector('[data-gp-cart-drawer]');
  if (!drawer || !window.fetch) return;
  var panel = drawer.querySelector('.gp-cart-drawer__panel');
  var itemsEl = drawer.querySelector('[data-gp-cart-items]');
  var emptyEl = drawer.querySelector('[data-gp-cart-empty]');
  var footerEl = drawer.querySelector('[data-gp-cart-footer]');
  var totalEl = drawer.querySelector('[data-gp-cart-total]');
  var statusEl = drawer.querySelector('[data-gp-cart-status]');
  var lastFocus = null;
  var emptyModal = document.querySelector('[data-gp-empty-cart-modal]');
  var emptyDialog = emptyModal ? emptyModal.querySelector('.gp-empty-cart-modal__dialog') : null;

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }
  function money(cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'EUR', maximumFractionDigits: 2 }).format((Number(cents) || 0) / 100); }
    catch (e) { return ((Number(cents) || 0) / 100).toFixed(2); }
  }
  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gp-cart-drawer-open');
    window.setTimeout(function () { if (panel) panel.focus(); }, 40);
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gp-cart-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function renderCart(cart) {
    itemsEl.innerHTML = '';
    var hasItems = cart.items && cart.items.length > 0;
    emptyEl.hidden = hasItems;
    footerEl.hidden = !hasItems;
    if (totalEl) totalEl.textContent = money(cart.total_price, cart.currency);
    cart.items.forEach(function (item) {
      var article = document.createElement('article');
      article.className = 'gp-cart-drawer__item';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var image = item.featured_image && item.featured_image.url ? '<div class="gp-cart-drawer__item-image"><img src="' + escapeHtml(item.featured_image.url) + '&width=220" alt="' + escapeHtml(item.product_title) + '"></div>' : '<div class="gp-cart-drawer__item-image"></div>';
      article.innerHTML = image +
        '<div><h3 class="gp-cart-drawer__item-title">' + escapeHtml(item.product_title) + '</h3>' +
        '<p class="gp-cart-drawer__item-meta">' + (variant ? escapeHtml(variant) + '<br>' : '') + 'Quantity: ' + escapeHtml(item.quantity) + '</p>' +
        '<button class="gp-cart-drawer__remove" type="button" data-gp-remove-key="' + escapeHtml(item.key) + '">Remove</button></div>' +
        '<div class="gp-cart-drawer__item-price">' + money(item.final_line_price, cart.currency) + '</div>';
      itemsEl.appendChild(article);
    });
    document.querySelectorAll('[data-gp-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('aria-hidden', cart.item_count ? 'false' : 'true'); });
  }
  function openEmptyModal() {
    if (!emptyModal) return;
    emptyModal.classList.add('is-open');
    emptyModal.setAttribute('aria-hidden', 'false');
    window.setTimeout(function () { if (emptyDialog) emptyDialog.focus(); }, 30);
  }
  function closeEmptyModal() {
    if (!emptyModal) return;
    emptyModal.classList.remove('is-open');
    emptyModal.setAttribute('aria-hidden', 'true');
  }
  function clearCart() {
    var confirmButton = emptyModal ? emptyModal.querySelector('[data-gp-empty-cart-confirm]') : null;
    if (confirmButton) confirmButton.setAttribute('aria-busy', 'true');
    statusEl.textContent = 'Clearing your selection…';
    return fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Unable to empty selection'); return response.json(); })
      .then(function (cart) { closeEmptyModal(); renderCart(cart); statusEl.textContent = 'Your selection is now empty.'; return cart; })
      .catch(function (error) { statusEl.textContent = error.message; })
      .finally(function () { if (confirmButton) confirmButton.removeAttribute('aria-busy'); });
  }
  function refreshCart(open) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load selection');
      return response.json();
    }).then(function (cart) { renderCart(cart); if (open) openDrawer(); return cart; });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    var submitter = event.submitter;
    if (submitter && (submitter.name === 'checkout' || submitter.closest('.shopify-payment-button'))) return;
    event.preventDefault();
    var button = submitter || form.querySelector('[type="submit"]');
    if (button) button.setAttribute('aria-busy', 'true');
    statusEl.textContent = 'Adding artwork to your selection…';
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Unable to add artwork'); }); return response.json(); })
      .then(function () { statusEl.textContent = 'Artwork added to your private selection.'; return refreshCart(true); })
      .catch(function (error) { statusEl.textContent = error.message; openDrawer(); })
      .finally(function () { if (button) button.removeAttribute('aria-busy'); });
  });

  document.addEventListener('click', function (event) {
    var emptyOpen = event.target.closest('[data-gp-empty-cart-open]');
    if (emptyOpen) { event.preventDefault(); openEmptyModal(); return; }
    var emptyCancel = event.target.closest('[data-gp-empty-cart-cancel]');
    if (emptyCancel) { event.preventDefault(); closeEmptyModal(); return; }
    var emptyConfirm = event.target.closest('[data-gp-empty-cart-confirm]');
    if (emptyConfirm) { event.preventDefault(); clearCart(); return; }
    var close = event.target.closest('[data-gp-cart-close]');
    if (close) { event.preventDefault(); closeDrawer(); return; }
    var remove = event.target.closest('[data-gp-remove-key]');
    if (remove) {
      event.preventDefault();
      remove.disabled = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: remove.getAttribute('data-gp-remove-key'), quantity: 0 }) })
        .then(function (response) { if (!response.ok) throw new Error('Unable to update selection'); return response.json(); })
        .then(renderCart).catch(function (error) { statusEl.textContent = error.message; });
      return;
    }
    var cartLink = event.target.closest('a[href]');
    if (cartLink) {
      try {
        var url = new URL(cartLink.href, window.location.origin);
        if (url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === '/cart' && !cartLink.closest('.gp-cart-drawer__secondary-actions')) {
          event.preventDefault(); refreshCart(true);
        }
      } catch (e) {}
    }
  });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') { if (emptyModal && emptyModal.classList.contains('is-open')) closeEmptyModal(); else if (drawer.classList.contains('is-open')) closeDrawer(); } });
  refreshCart(false).catch(function () {});
});

/* Gallery Privé emergency mobile dropdown controller - 08 Jul 2026 */
document.addEventListener('DOMContentLoaded', function () {
  var nav = document.querySelector('.gp-global-nav');
  var toggle = document.querySelector('[data-gp-global-menu-toggle]');
  if (!nav || !toggle) return;

  function setOpen(open) {
    nav.classList.toggle('is-mobile-open', open);
    document.body.classList.toggle('gp-mobile-menu-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    var text = toggle.querySelector('.gp-global-nav__toggle-text');
    if (text) text.textContent = open ? 'Close' : 'Menu';
  }

  toggle.addEventListener('click', function (event) {
    event.preventDefault();
    setOpen(!nav.classList.contains('is-mobile-open'));
  });

  nav.querySelectorAll('[data-gp-submenu-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      if (!window.matchMedia('(max-width: 900px)').matches) return;
      event.preventDefault();
      var item = trigger.closest('.gp-global-nav__item');
      if (!item) return;
      var nowOpen = !item.classList.contains('is-submenu-open');
      nav.querySelectorAll('.gp-global-nav__item.is-submenu-open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-submenu-open');
          var openTrigger = openItem.querySelector('[data-gp-submenu-trigger]');
          if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.toggle('is-submenu-open', nowOpen);
      trigger.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
    });
  });

  nav.querySelectorAll('.gp-global-nav__dropdown a[href], .gp-global-nav__links > a[href]').forEach(function (link) {
    link.addEventListener('click', function () {
      if (window.matchMedia('(max-width: 900px)').matches && link.getAttribute('href') !== '#') setOpen(false);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setOpen(false);
  });

  window.addEventListener('resize', function () {
    if (!window.matchMedia('(max-width: 900px)').matches) setOpen(false);
  });
});

/* Gallery Privé language and region selectors */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-gp-localization-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form');
      if (form) form.submit();
    });
  });
});
